import { render, staticRenderFns } from "./DocumentReportDash.vue?vue&type=template&id=fa83b6d0&scoped=true"
import script from "./DocumentReportDash.vue?vue&type=script&lang=js"
export * from "./DocumentReportDash.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa83b6d0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
